import { ROUTE_PATH_ACTIVATE, URL_INTX_LOGIN_PAGE_FR_CA } from '../../constants';
import { AlertsPageTranslations } from '../types';

export const translations: AlertsPageTranslations = {
  docTitle: 'Surveillance et alertes',
  pageTitle: 'Surveillance et alertes',
  featureList: [
    {
      // 'key' MUST BE the same as array index
      key: '0',
      heading: 'Une protection constante pour vous aider à vous prémunir contre la fraude d’identité.',
      summary: [
        '<p>Le moyen le plus efficace de vous prémunir contre la fraude d’identité est de savoir où et comment vos renseignements personnels sont utilisés.',
        'Grâce à la surveillance et aux alertes, vous pouvez vous tenir au courant des activités liées',
        'à votre identité financière et virtuelle et réagir rapidement à une fraude possible.</p>'
      ].join('\n')
    },
    {
      key: '1',
      heading: 'Surveillance de l’identité virtuelle',
      summary: [
        '<p>Nous examinerons les sites Web clandestins et du marché noir afin d’y relever la présence d’informations personnelles que vous enregistrez, y compris les adresses',
        'électroniques, le permis de conduire, le numéro d’assurance sociale, etc. Vous serez ainsi conscient de vos informations personnelles qui pourraient avoir été compromises.</p>',

        '<h2 class="feature-item-heading">Surveillance de l’identité financière</h2>',
        '<p>Les nouvelles demandes de crédit ou de prêt liées à votre dossier de crédit',
        'seront surveillées afin de vous tenir au courant de certaines activités qui pourraient indiquer que des fraudes ont été commises en votre nom.</p>',

        '<h2 class="feature-item-heading">Alertes relatives à l’identité</h2>',
        '<p>Si nous trouvons vos renseignements personnels en ligne ou si de nouvelles demandes de crédit sont faites en votre nom, vous en serez informé afin',
        'que vous puissiez agir rapidement pour mieux vous protéger contre les activités que vous n’avez pas autorisées.</p>'
      ].join('\n'),
      action: {
        login: {
          to: '',
          href: URL_INTX_LOGIN_PAGE_FR_CA,
          children: 'Ouverture de session'
        },
        activate: {
          to: ROUTE_PATH_ACTIVATE,
          children: 'Activer'
        }
      }
    }
  ]
};
